import { CaretDownOutlined, CaretUpOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Col, Input, Row, Select, Tag, Tooltip } from 'antd'
import { SLocalTreeSelected, STitle } from 'shj-components'
import { useEffect, useState } from 'react'
import { useUpdateEffect } from 'ahooks'
import { useLocation, useParams, useSearchParams } from 'react-router-dom'
import style from './index.module.less'
import {
  getSelectGeneralTerm,
  getTradeEnums,
  listBrand,
  listProductCategory,
  queryActivity,
  selectBrandByGeneralTerm,
} from '@/services/order'
import { getUser, treeToOneArr } from '@/common/utils.ts'
import { batchGetForAuth, batchSaveOrUpdateForAuth } from '@/services/cache'
import { getProductEnums } from '@/services/product'

type Iprops = {
  setSearchParams: (v) => void
  tableLoading: boolean // 表格搜索状态
}
export const SearchBar = (props: Iprops) => {
  const { tableLoading } = props
  const params = useParams()
  const budgetId = params.budgetId //报价id
  const type = params.type || 'PROJECT' //当前选材类型
  let [searchParams, setSearchParams] = useSearchParams()
  const generalItemManageId = searchParams?.get('generalItemManageId') || '' // 带入通项id
  const [brandId, setBrandId] = useState<any>('不限') // 品牌
  const [searchKeyWord, setSearchKeyWord] = useState('') // 物料编码
  const [productCategoryIds, setProductCategoryIds] = useState<any>(undefined) // 分类
  const [generalId, setGeneralId] = useState<any>(undefined) // 通项ID
  const [templateList, setTemplateList] = useState([]) // 左侧 通项列表
  const [brandList, setBrandList] = useState<any>([])
  const [categoryList, setCategoryList] = useState<any>([]) // 产品分类列表数据
  const [historyName, setHistoryName] = useState('') // 历史记录搜索字段
  const [subType, setSubType] = useState(undefined) // 减项类型值
  const [subTypeList, setSubTypeList] = useState([]) // 减项类型枚举
  const [historyList, setHistoryList] = useState<any[]>([]) // 历史搜索记录展示列表
  const [activityList, setActivityList] = useState<any[]>([]) // 活动列表
  const [activityId, setActivityId] = useState<any>(undefined) // 活动ID
  const [addType, setAddType] = useState<any>('PRODUCT') // 来源类型
  const [prodType, setProdType] = useState<any>(undefined) // 产品类型
  const [productTypeList, setProductTypeList] = useState<any>([]) // 产品类型列表
  const [productSourceTypeBus, setProductSourceTypeBus] = useState<any>('all') // 主材施工类型
  const [productSourceTypeBusList, setProductSourceTypeBusList] = useState<any>([]) // 主材施工类型
  const user = getUser()
  const cacheStr = `history_material_search_${user?.workNumber}_${budgetId}_${type}` //缓存key
  // 配置不通选材类型下的搜索条件显示
  const typeSearchFlag = {
    ACTIVITY: {
      activity: true,
    },
    ADD: {
      productCategory: true,
      brand: true,
      addType: true,
      prodType: true,
      mainMaterial: true,
    },
    SUB: {
      subType: true,
      brand: true,
    },
    GENERAL: {
      general: true,
      brand: true,
      mainMaterial: true,
    },
    PROJECT: {
      productCategory: true,
      brand: true,
      mainMaterial: true,
    },
    UP_DOWN: {
      general: true,
      brand: true,
      mainMaterial: true,
    },
  }
  useEffect(() => {
    fetchTemplateList()
    switch (type) {
      case 'ADD':
        fetchCategoryList()
        // 品牌默认获取
        fetchBrandList()
        fetchProductTypeList()
        fetchProductSourceTypeBusList()
        break
      case 'SUB':
        // 获取减项类型
        fetchSubTypeList()
        fetchBrandList()
        break
      case 'PROJECT':
        fetchCategoryList()
        // 品牌默认获取
        fetchBrandList()
        fetchProductSourceTypeBusList()
        break
      case 'ACTIVITY':
        fetchActivityList()
        break
      case 'UP_DOWN':
        fetchTemplateList()
        fetchBrandList()
        fetchProductSourceTypeBusList()
        break
      case 'GENERAL':
        fetchProductSourceTypeBusList()
        break
      default:
        break
    }
    getCacheHistory()
  }, [])
  // 获取通项下拉数据
  const fetchTemplateList = async () => {
    const res = await getSelectGeneralTerm({
      data: {
        quoteBudgetId: budgetId,
        isUpDown: type === 'UP_DOWN',
      },
    })
    setGeneralId(generalItemManageId || res[0]?.id)
    setTemplateList(res)
  }
  // 获取分类下拉数据
  const fetchCategoryList = async () => {
    const res = await listProductCategory({
      data: {
        quoteBudgetId: budgetId,
      },
    })
    const data = handleTreeData(res)
    setCategoryList(data)
  }
  //  树结构数据处理
  const handleTreeData = data => {
    if (Array.isArray(data)) {
      data.map(item => {
        item.title = item.label
        item.value = item.id
        if (item.children && item.children.length) {
          handleTreeData(item.children)
        }
      })
    }
    return data
  }
  // 获取品牌数据
  const fetchBrandList = async () => {
    listBrand({
      data: {
        quoteBudgetId: budgetId,
      },
    }).then(res => {
      let array = Array.isArray(res) ? res : []
      array = array.map(item => {
        return {
          label: item.sourceName,
          value: item.sourceId,
        }
      })
      setBrandList([...array])
      // setBrandId('不限')
    })
  }
  // 获取活动数据
  const fetchActivityList = async () => {
    let activityList: any = await queryActivity({
      params: {
        budgetId: budgetId,
      },
    })
    activityList = activityList.map(item => {
      return {
        label: item.name,
        value: item.id,
      }
    })
    setActivityId('不限')
    setActivityList(activityList)
  }
  // 获取减项类型
  const fetchSubTypeList = async () => {
    const res = await getTradeEnums('com.shj.saas.plus.trade.enums.SubtractTypeEnum')

    setSubTypeList(res)
    // setSubType(res[0]?.key)
  }
  const fetchProductTypeList = async () => {
    const productTypeList = await getProductEnums('com.shj.saas.plus.product.enums.ProductTypeEnum')
    setProductTypeList(
      productTypeList?.map(item => {
        return {
          label: item.description,
          value: item.key,
        }
      })
    )
  }
  const fetchProductSourceTypeBusList = async () => {
    const list = await getTradeEnums(
      'com.shj.saas.plus.trade.domain.quote.enums.ProductSourceTypeBusEnum'
    )
    setProductSourceTypeBusList(
      list?.map(item => {
        return {
          label: item.description,
          value: item.key,
        }
      })
    )
  }
  // 获取缓存历史记录
  const getCacheHistory = async () => {
    const data = await batchGetForAuth({ data: [cacheStr] })
    if (data && data[cacheStr]) {
      setHistoryList(data[cacheStr].value)
    }
  }
  useUpdateEffect(() => {
    // 根据通项查品牌
    selectBrandByGeneralTerm({
      data: { generalItemManageId: type === 'GENERAL' ? generalId : '', quoteBudgetId: budgetId },
    }).then(res => {
      let array = Array.isArray(res) ? res : []
      array = array.map(item => {
        return {
          label: item.sourceName,
          value: item.sourceId,
        }
      })
      setBrandList([...array])
      // setBrandId('不限')
    })
  }, [generalId])

  // 设置缓存历史记录
  const setCacheHistory = () => {
    batchSaveOrUpdateForAuth({
      data: [
        {
          key: cacheStr,
          value: historyList,
        },
      ],
    })
  }
  // 监听参数变化
  useUpdateEffect(() => {
    console.log('监听参数变化')
    clickToSearch()
  }, [
    brandId,
    historyName,
    productCategoryIds,
    generalId,
    subType,
    activityId,
    addType,
    prodType,
    productSourceTypeBus,
  ])

  // 物料搜索变化
  const onsearchChange = e => {
    setSearchKeyWord(e.target.value)
  }
  // 查询
  const clickToSearch = () => {
    if (searchKeyWord) {
      if (historyList.length < 3) {
        historyList.unshift(searchKeyWord)
      } else {
        historyList.pop()
        historyList.unshift(searchKeyWord)
      }
      setHistoryList(historyList)
      setCacheHistory()
    }
    // 如果是通项查询 需要查 generalIsStandard 字段
    let generalIsStandardObj
    if (generalId) {
      generalIsStandardObj = templateList.find(item => item.id === generalId)
    }
    props.setSearchParams({
      searchKeyWord,
      productCategoryIds,
      brandId,
      generalId,
      subType,
      activityId,
      addType,
      prodType,
      generalIsStandard: generalIsStandardObj?.generalIsStandard,
      productSourceTypeBus,
    })
  }

  const onBrandChange = e => {
    setBrandId(e)
  }
  const onaddTypeChange = e => {
    setAddType(e)
  }
  const onProductTypeChange = e => {
    setProdType(e)
  }
  const onActivityChange = e => {
    setActivityId(e)
  }
  const productCategoryChange = e => {
    let ids: any = []
    if (e) {
      let newList = treeToOneArr(categoryList)
      let infoObj: any = newList.find(item => item.id === e)
      findAllId(infoObj, ids)
    }
    setProductCategoryIds(ids)
  }
  const findAllId = (obj: any, ids) => {
    ids.push(obj.id)
    if (obj.children && obj.children.length > 0) {
      obj.children.forEach(item => {
        findAllId(item, ids)
      })
    }
  }
  const onProductSourceTypeBusChange = e => {
    setProductSourceTypeBus(e)
  }
  // 搜索函数
  return (
    <div style={{ padding: '15px', paddingBottom: '10px' }}>
      <STitle title={'选择产品'} style={{ marginBottom: '5px' }} />
      {type === 'ADD' && (
        <Row align="middle" gutter={[8, 20]} style={{ minHeight: '40px', marginTop: '0px' }}>
          <Col flex="70px">来源类型</Col>
          <Col flex="1" style={{ paddingRight: 0 }}>
            <Select
              disabled={tableLoading}
              style={{ width: '100%' }}
              showSearch
              value={addType}
              onChange={onaddTypeChange}
              className={style.categorySelect}
              // onSearch={onSearch}
              options={[
                { label: '通项', value: 'GENERAL' },
                { label: '产品', value: 'PRODUCT' },
                { label: '已减标配', value: 'REDUCED_STANDARD' },
              ]}
              optionFilterProp="label"
            />
          </Col>
          {addType === 'PRODUCT' ? (
            <>
              <Col flex="70px">产品类型</Col>
              <Col flex="1" style={{ paddingRight: 0 }}>
                <Select
                  disabled={tableLoading}
                  style={{ width: '100%' }}
                  showSearch
                  allowClear
                  value={prodType}
                  onChange={onProductTypeChange}
                  className={style.categorySelect}
                  // onSearch={onSearch}
                  placeholder="请选择产品类型"
                  options={productTypeList?.filter((item: any) =>
                    ['PRODUCT_SINGLE', 'PRODUCT_GROUP'].includes(item.value)
                  )}
                  optionFilterProp="label"
                />
              </Col>
            </>
          ) : (
            <>
              <Col flex="70px" style={{ textAlign: 'center' }}>
                名称
              </Col>
              <Col flex="1" style={{ paddingRight: 0, paddingLeft: 0 }}>
                <Input
                  onKeyDown={e => {
                    if (e.keyCode === 13) {
                      clickToSearch()
                    }
                  }}
                  style={{ borderRadius: 0, width: '100%' }}
                  disabled={tableLoading}
                  placeholder={addType === 'GENERAL' ? '通项名称' : '产品SKU名称'}
                  value={searchKeyWord}
                  allowClear
                  onChange={onsearchChange}
                />
              </Col>
              <Col flex="70px" style={{ paddingLeft: 0, paddingRight: 0, textAlign: 'right' }}>
                <Button
                  type="primary"
                  style={{ borderRadius: 0 }}
                  disabled={tableLoading}
                  onClick={clickToSearch}
                >
                  搜索
                </Button>
              </Col>
            </>
          )}
        </Row>
      )}

      {addType === 'PRODUCT' && (
        <Row align="middle" gutter={[8, 20]} style={{ minHeight: '40px', marginTop: '0px' }}>
          {typeSearchFlag[type].productCategory && (
            <>
              <Col flex="70px">产品分类</Col>
              <Col flex="1" style={{ paddingRight: 0 }}>
                <SLocalTreeSelected
                  disabled={tableLoading}
                  placeholder="请选择"
                  value={productCategoryIds}
                  onChange={(value: string) => productCategoryChange(value)}
                  style={{ width: '100%' }}
                  className={style.categorySelect}
                  treeData={categoryList}
                />
              </Col>
            </>
          )}
          {typeSearchFlag[type].subType && (
            <>
              <Col flex="70px">减项类型</Col>
              <Col flex="1" style={{ paddingRight: 0 }}>
                <Select
                  disabled={tableLoading}
                  placeholder="请选择"
                  value={subType}
                  onChange={(value: string) => {
                    setSubType(value)
                  }}
                  allowClear
                  style={{ width: '100%' }}
                  className={style.categorySelect}
                  options={subTypeList}
                  fieldNames={{ label: 'description', value: 'key' }}
                />
              </Col>
            </>
          )}
          {/* 筛选通项 */}
          {typeSearchFlag[type].general && (
            <>
              <Col flex="70px">通项</Col>
              <Col flex="1" style={{ paddingRight: 0 }}>
                <Select
                  disabled={tableLoading}
                  // defaultValue="lucy"
                  style={{ width: '100%' }}
                  value={generalId}
                  onChange={value => {
                    setGeneralId(value)
                  }}
                  // allowClear
                  className={style.categorySelect}
                  fieldNames={{ label: 'name', value: 'id' }}
                  options={templateList}
                  showSearch
                  optionFilterProp="name"
                />
              </Col>
            </>
          )}
          {/* 是否显示活动搜索 */}
          {typeSearchFlag[type].activity && (
            <>
              <Col flex="70px">活动：</Col>
              <Col flex="1" style={{ paddingRight: 0 }}>
                <Select
                  disabled={tableLoading}
                  style={{ width: '100%' }}
                  showSearch
                  allowClear
                  value={activityId}
                  onChange={onActivityChange}
                  className={style.categorySelect}
                  // onSearch={onSearch}
                  options={[{ label: '不限', value: '' }, ...activityList]}
                  optionFilterProp="label"
                />
              </Col>
            </>
          )}
          {/* 默认显示搜索条件 */}
          <Col flex="1" style={{ paddingRight: 0, paddingLeft: 0 }}>
            <Input
              onKeyDown={e => {
                if (e.keyCode === 13) {
                  clickToSearch()
                }
              }}
              style={{ borderRadius: 0, width: '100%' }}
              disabled={tableLoading}
              placeholder={
                ['SUB', 'ACTIVITY'].includes(type)
                  ? '搜索产品名称/编码'
                  : '产品SPU名称/SPU_ID/SKU_ID/物料ID'
              }
              value={searchKeyWord}
              allowClear
              onChange={onsearchChange}
            />
          </Col>
          <Col flex="70px" style={{ paddingLeft: 0, paddingRight: 0, textAlign: 'right' }}>
            <Button
              type="primary"
              style={{ borderRadius: 0 }}
              disabled={tableLoading}
              onClick={clickToSearch}
            >
              搜索
            </Button>
          </Col>
        </Row>
      )}
      {/* 品牌 */}
      {/* 减项类型时 非通项才显示 */}

      {typeSearchFlag[type].brand && subType !== 'GENERAL' && addType === 'PRODUCT' && (
        <Row align="middle" gutter={[8, 20]} style={{ minHeight: '40px', marginTop: '0px' }}>
          <Col flex="70px">品牌</Col>
          <Col flex="1" style={{ paddingRight: 0 }}>
            <Select
              disabled={tableLoading}
              style={{ width: '100%' }}
              showSearch
              allowClear
              value={brandId}
              onChange={onBrandChange}
              className={style.categorySelect}
              // onSearch={onSearch}
              options={[{ label: '不限', value: '' }, ...brandList]}
              optionFilterProp="label"
            />
          </Col>
          {/* 占位展示 */}
          {typeSearchFlag[type].mainMaterial ? (
            <>
              <Col flex="70px">主材/施工</Col>
              <Col flex="1" style={{ paddingRight: 0, paddingLeft: 0 }}>
                <Select
                  disabled={tableLoading}
                  style={{ width: '100%' }}
                  showSearch
                  value={productSourceTypeBus}
                  onChange={onProductSourceTypeBusChange}
                  className={style.categorySelect}
                  // onSearch={onSearch}
                  options={[{ label: '全部', value: 'all' }, ...productSourceTypeBusList]}
                  optionFilterProp="label"
                />
              </Col>
            </>
          ) : (
            <>
              <Col flex="70px"></Col>
              <Col flex="1" style={{ paddingRight: 0, paddingLeft: 0 }}></Col>
            </>
          )}
        </Row>
      )}
      {/* 历史搜索记录 */}
      <Row align="middle" gutter={[8, 8]} style={{ marginTop: '0px' }}>
        <Col flex="70px"></Col>
        {historyList &&
          historyList.map((item, index) => {
            return (
              <Col key={index} style={{ maxWidth: '124px' }}>
                <Tag
                  key={index}
                  style={{
                    cursor: 'pointer',
                    maxWidth: '120px',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                  }}
                  onClick={() => {
                    if (tableLoading) return
                    setSearchKeyWord(item)
                    setHistoryName(item)
                  }}
                >
                  <Tooltip title={item}>
                    <span> {item}</span>
                  </Tooltip>
                </Tag>
              </Col>
            )
          })}
      </Row>
    </div>
  )
}
